<template>
  <v-flex xs12>
    <v-card>
      <v-card-title>
        <v-flex xs12 class="mb-5">
          <h4>{{ pageTitle }}</h4>
        </v-flex>
        <v-flex xs12>
          <v-form ref="form" lazy-validation @submit.prevent="submit">
            <v-container grid-list-xl>
              <v-layout wrap>
                <v-flex xs12 md6>
                  <v-select
                    v-model="type"
                    :items="typeList"
                    name="type"
                    label="Type"
                    v-validate="'required'"
                    data-vv-as="Type"
                    :error-messages="errors.collect('type')"
                    item-text="name"
                    item-value="id"
                  ></v-select>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="name"
                    name="name"
                    label="Name"
                    :counter="50"
                    v-validate="'required|max:50'"
                    data-vv-as="Name"
                    :error-messages="errors.collect('name')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md1>
                  <v-btn color="info" type="button" @click="imagePicked">
                    <v-icon>cloud_upload</v-icon>Image
                  </v-btn>
                  <input
                    type="file"
                    style="display: none"
                    ref="ImageUploader"
                    accept="image/*"
                    @change="onImagePicked"
                  />
                </v-flex>
                <v-flex xs12 md4>
                  <vue-cropper
                    ref="cropper"
                    :aspect-ratio="ratio"
                    :src="mainImage"
                    :imageSmoothingEnabled="false"
                    alt="Upload Image"
                  ></vue-cropper>
                  <!-- <img :src="image" style="width:100%" v-if="image" /> -->
                  <br />
                  <v-btn color="info" type="button" @click="crop" v-if="showCrop">
                    <v-icon>crop</v-icon>Crop
                  </v-btn>
                </v-flex>
                <v-flex xs12 md4>
                  <img v-if="image" :src="image" alt="Cropped Image" style="width:100%" />
                </v-flex>
              </v-layout>
            </v-container>

            <v-divider class="mt-5"></v-divider>
            <v-card-actions>
              <v-btn color="success" type="submit">
                <v-icon>save</v-icon>Save
              </v-btn>
              <v-btn color="error" @click="reset">Reset</v-btn>
            </v-card-actions>
          </v-form>
        </v-flex>
      </v-card-title>
    </v-card>
  </v-flex>
</template>

<script>
import store from "../../store";
import commonservice from "../../shared/common.service";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
export default {
  components: { VueCropper },
  computed: {
    name: {
      get() {
        return this.$store.state.contentImage.entity.name;
      },
      set(val) {
        this.$store.commit("contentImage/SET_CONTENT_IMAGE_DATA", {
          key: "name",
          value: val
        });
      }
    },
    type: {
      get() {
        return this.$store.state.contentImage.entity.type;
      },
      set(val) {
        if (val === "MAINIMAGE") {
          this.ratio = 1.29;
        } else if (val === "MAP") {
          this.ratio = 16 / 9;
        } else {
          this.ratio = 16 / 9;
        }
        this.$refs.cropper.setAspectRatio(this.ratio);
        this.$store.commit("contentImage/SET_CONTENT_IMAGE_DATA", {
          key: "type",
          value: val
        });
        this.$store.commit("contentImage/SET_CONTENT_IMAGE_DATA", {
          key: "image",
          value: null
        });
      }
    },
    image: {
      get() {
        return this.$store.state.contentImage.entity.image;
      },
      set(val) {
        this.$store.commit("contentImage/SET_CONTENT_IMAGE_DATA", {
          key: "image",
          value: val
        });
      }
    },
    mainImage: {
      get() {
        return this.$store.state.contentImage.mainImage;
      },
      set(val) {
        this.$store.commit("contentImage/SET_MAIN_IMAGE", val);
      }
    },
    typeList: {
      get() {
        return this.$store.state.contentImage.typeList;
      }
    }
  },
  data() {
    return {
      pageTitle: "Add Content Image",
      loading: false,
      menu: false,
      menu1: false,
      ratio: 16 / 9,
      showCrop: false
    };
  },
  beforeRouteEnter(to, from, next) {
    if (to.params.id) {
      store
        .dispatch("contentImage/setContentImage", { id: to.params.id })
        .then(() => {
          next(p => {
            p.pageTitle = "Edit Content Image";
          });
        });
    } else {
      if (store.state.contentImage.entity.contentId) {
        next(p => {
          p.reset();
        });
      } else {
        next("/content");
      }
    }
  },
  methods: {
    submit() {
      if (this.loading) return;
      if (this.image == null) {
        commonservice.showErrorMessage("Please upload image");
        return;
      }
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.loading = true;
          this.$store
            .dispatch("contentImage/save")
            .then(
              () => {
                commonservice.showSuccessMessage("Image saved successfully");
                this.$router.push("/contentImage");
                this.loading = false;
              },
              () => {
                this.loading = false;
              }
            )
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },
    reset() {
      this.$store.commit("contentImage/RESET");
      setTimeout(() => {
        this.errors.clear();
      }, 10);
    },
    imagePicked() {
      this.$refs.ImageUploader.click();
    },
    crop() {
      var self = this;
      // get image data for post processing, e.g. upload or setting image src
      var cropIm = self.$refs.cropper
        .getCroppedCanvas({ imageSmoothingEnabled: false })
        .toDataURL("image/jpeg", 0.7);
      self.$store.commit("contentImage/SET_CONTENT_IMAGE_DATA", {
        key: "image",
        value: cropIm
      });
    },
    onImagePicked(event) {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      var self = this;
      reader.onload = function() {
        self.$store.commit("contentImage/SET_MAIN_IMAGE", reader.result);
        self.$refs.cropper.replace(reader.result);
        self.showCrop = true;
      };
    }
  }
};
</script>
